'use strict';

angular.module('imagetrend.components')
    .directive('hlpSubmit', ['Format', 'Permissions', '$rootScope', function (Format, Permissions, $rootScope) {
        return {
            restrict: 'AE',
            scope: {
                id: '@?',
                label: '@?',
                title: '@?',
                classes: '@?',
                //submitting: '=?',
                loading: '=?',
                loadingText: '@?',
                permission: '@?',
                permissionState: '@?',
                filterFound: '=?'
            },
            replace: true,
            require: '^hlpButtonGroup',
            templateUrl: 'templates/submit/submit.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = 'submit'; }
                if (!attrs.label) { attrs.label = 'Save'; }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.classes) { attrs.classes = 'save'; }
                if (!attrs.loadingText) { if (attrs.loading) { attrs.loadingText = Format.label(attrs.loading) } else { attrs.loadingText = 'Saving'; } }
                if (!attrs.permissionState && $rootScope.$state != null && $rootScope.$state.current != null) { attrs.permissionState = $rootScope.$state.current.name; }
                // Used to disable submit on Public Lookup, don't disable if the value isn't passed in (submit used elsewhere)
                if (scope.filterFound === undefined) { scope.filterFound = true; }

                if (attrs.permission != null && attrs.permissionState != null) {
                    Permissions[attrs.permission](attrs.permissionState).then(function (access) {
                        scope.hasPermission = access;
                    })
                }
                else {
                    scope.hasPermission = true;
                }

                scope.$watch('loading', function (loading) {
                    if (loading != null) {
                        ctrl.setLoader(loading, scope.classes, scope.loadingText);
                    }
                });

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off(); // deregister all event handlers
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])

;